import { createApi } from '@stilingue/st-auth-utils';
import Service from './Service';
import { dateInMilliseconds } from '../utils/date';
import colors from '@/utils/colors';

const {
  positiveColor,
  negativeColor,
} = colors;
const gateway = process.env.VUE_APP_SERVICES_PROXY_URL || '';

const afterParser = (response) => {
  return response.data;
};

class WarRoomService extends Service {
  constructor(gateway) {
    const api = createApi('/stocks', gateway, {
      authNotFound: () => true,
    });

    super(api, {
      afterParser,
      retriesLimit: 3,
    });

    this.api.http.defaults.timeout = 300000;
  }

  async getStocksData(params = {}) {
    const realParams = {
      symbol: params.params.stockParams.stockSymbol,
      function: 'TIME_SERIES_DAILY',
      outputsize: 'compact',
    };
    const response = await this.find({
      params: realParams,
      url: '/',
    });

    const { startSearch, endSearch } = getStartAndEndSearch(params.params.date_range);
    const finalResponse = [];

    Object.entries(response['Time Series (Daily)']).forEach(([key, value]) => {
      const myDate = new Date(key);
      if (myDate.getTime() > startSearch && myDate.getTime() < endSearch) {
        finalResponse.push({
          price: Number(value['4. close']),
          volume: Number(value['5. volume']),
          color: Number(value['1. open']) < Number(value['4. close']) ? positiveColor : negativeColor,
          date: myDate.getTime(),
        });
      }
    });

    return finalResponse;
  }
}

function getStartAndEndSearch(date_range) {
  const tenDaysInTimestamp = 864000000;
  const startSearch = Number(dateInMilliseconds(date_range.slice(0, date_range.indexOf(':'))) - tenDaysInTimestamp);
  const endSearch = Number(dateInMilliseconds(date_range.slice(date_range.indexOf(':') + 1, date_range.length)));
  return { startSearch, endSearch };
}
export default new WarRoomService(gateway);
